// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"oq-z","breadcrumbForward":"pq-z","breadcrumbBack":"qq-z","selected":"rq-z"};